import React from 'react';
import { useInsuranceReportQuery } from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';
import FormattedMomentDate, {
	DateFormat,
} from '../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import Text from '../../../../Components/Base/Text/Text';
// @ts-ignore
import styles from './InsuranceReportDetail.module.scss';

interface Props {
	insuranceReportId: string;
}

const InsuranceReportDetail: React.FC<Props> = ({ insuranceReportId }) => {
	const { data, isLoading } = useInsuranceReportQuery({
		id: insuranceReportId,
	});

	const item = data?.insuranceReport;

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			{item?.createdAt && (
				<div className={styles.item}>
					<Text
						tx='component.insuranceReportDetail.createdAt'
						className={styles.title}
						colon
					/>
					<div className={styles.text}>
						<FormattedMomentDate
							date={item.createdAt}
							format={DateFormat.DATE_TIME}
						/>
					</div>
				</div>
			)}
			{item?.diagnosis && (
				<div className={styles.item}>
					<Text
						tx='component.insuranceReportDetail.diagnosis'
						className={styles.title}
						colon
					/>
					<div className={styles.text}>{item.diagnosis}</div>
				</div>
			)}
			{item?.operation && (
				<div className={styles.item}>
					<Text
						tx='component.insuranceReportDetail.operation'
						className={styles.title}
						colon
					/>
					<div className={styles.text}>{item.operation.title}</div>
				</div>
			)}
			{item?.count && (
				<div className={styles.item}>
					<Text
						tx='component.insuranceReportDetail.count'
						className={styles.title}
						colon
					/>
					<div className={styles.text}>{item.count}</div>
				</div>
			)}
			{item?.points && (
				<div className={styles.item}>
					<Text
						tx='component.insuranceReportDetail.points'
						className={styles.title}
						colon
					/>
					<div className={styles.text}>{item.points}</div>
				</div>
			)}
		</div>
	);
};

export default InsuranceReportDetail;
